import React from 'react';
import './ ActiveFilters.css';

const ActiveFilters = ({
    selectedFilters,
    onRemoveFilter,
    onRemoveTextTag,
    onClearDateRange,
    onClearAllFilters
}) => {
    const hasActiveFilters = () => {
        return (
            selectedFilters.juridiction.length > 0 ||
            selectedFilters.portee.length > 0 ||
            selectedFilters.publication.length > 0 ||
            selectedFilters.dispositif.length > 0 ||
            selectedFilters.textesCites.length > 0 ||
            selectedFilters.textesNonCites.length > 0 ||
            selectedFilters.dateRange.start ||
            selectedFilters.dateRange.end
        );
    };

    if (!hasActiveFilters()) {
        return null;
    }

    return (
        <div className="active-filters">
            <div className="active-filters-header">
                <span>Filtres actifs:</span>
                <button className="clear-all-filters" onClick={onClearAllFilters}>
                    Effacer tout
                </button>
            </div>

            <div className="filter-chips">
                {selectedFilters.juridiction.map(item => (
                    <div key={`juridiction-${item}`} className="filter-chip">
                        <span>Juridiction: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveFilter('juridiction', item)}>×</button>
                    </div>
                ))}

                {(selectedFilters.dateRange.start || selectedFilters.dateRange.end) && (
                    <div className="filter-chip">
                        <span>
                            Date: {selectedFilters.dateRange.start || 'Début'} - {selectedFilters.dateRange.end || 'Aujourd\'hui'}
                        </span>
                        <button className="remove-chip" onClick={() => onClearDateRange('dateRange')}>×</button>
                    </div>
                )}

                {selectedFilters.portee.map(item => (
                    <div key={`portee-${item}`} className="filter-chip">
                        <span>Portée: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveFilter('portee', item)}>×</button>
                    </div>
                ))}

                {selectedFilters.publication.map(item => (
                    <div key={`publication-${item}`} className="filter-chip">
                        <span>Publication: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveFilter('publication', item)}>×</button>
                    </div>
                ))}

                {selectedFilters.dispositif.map(item => (
                    <div key={`dispositif-${item}`} className="filter-chip">
                        <span>Dispositif: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveFilter('dispositif', item)}>×</button>
                    </div>
                ))}

                {selectedFilters.textesCites.map(item => (
                    <div key={`textesCites-${item}`} className="filter-chip">
                        <span>Textes cités: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveTextTag('textesCites', item)}>×</button>
                    </div>
                ))}

                {selectedFilters.textesNonCites.map(item => (
                    <div key={`textesNonCites-${item}`} className="filter-chip">
                        <span>Textes non cités: {item}</span>
                        <button className="remove-chip" onClick={() => onRemoveTextTag('textesNonCites', item)}>×</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActiveFilters;